
<template>
  <!--住房信息-->
  <div>
    <x-tabula
      ref="table"
      :searchList="searchList"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :columns="columns"
      :dataSource="dataSource"
      rowKey="householderInfoId"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_expireTime" slot-scope="{row}">
        <span>{{row.expireTime | foreverTime}}</span>
      </template>
    </x-tabula>

    <!--续期的弹窗-->
    <a-modal
      title="续期"
      :visible="visible"
      @ok="handleSubmit"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      okText="确认"
      cancelText="取消"
      destroyOnClose
      centered
      :maskClosable="false"
      :keyboard="false"
    >
      <a-form :form="form">
        <a-form-item v-bind="$store.state.modal_ItemLayout" label="截止时间">
          <a-date-picker v-decorator="['expireTime', fromOptions.expireTime]" format="YYYY-MM-DD"/>
        </a-form-item>
      </a-form>
    </a-modal>

    <!--添加住房的弹窗-->
    <a-modal
      title="添加住房"
      :visible="houseVisible"
      @ok="$refs.addEdit.handleSubmit()"
      @cancel="closeHouseVisible"
      :confirmLoading="btnLoading.loading"
      centered
      :maskClosable="false"
      :keyboard="false"
      okText="确认"
      cancelText="取消"
      destroyOnClose
      :width="900"
    >
      <x-addEdit
        ref="addEdit"
        formType="modal"
        :isSubmitBtn="false"
        :reqLoading="btnLoading"
        :formList="formList"
        :addParam="addParam"
      >
      </x-addEdit>
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
import Moment from 'moment';
export default {
  mixins: [fetchSelect],
  name: 'housingInfo',
  data () {
    let decoratorOptions = {
      communityId: {
        rules: [{ required: true, message: '请选择所在小区' }]
      },
      buildingId: {
        rules: [{ required: true, message: '请选择所在楼栋' }]
      },
      unitId: {
        rules: [{ required: true, message: '请选择所在单元' }]
      },
      roomId: {
        rules: [{ required: true, message: '请选择所在房间' }]
      },
      householdType: {
        rules: [{ required: true, message: '请选择住户类型' }]
      },
      expireTime: {
        rules: [{ required: true, message: '请选择有效期' }]
      }
    };
    return {
      visible: false,
      btnLoading: { loading: false },
      houseVisible: false,
      houseLoading: false,
      householderData: {},
      searchList: [],
      tableOptList: [
        { text: '添加房间', icon: 'plus', handle: this.addHouse, key: 'addbtn' }
      ],
      rowOptList: [
        { text: '删除', handle: (row) => this.$refs.table.showDeleteConfirm(row), key: 'delete' },
        { text: '续期', handle: (row) => this.openModal(row), key: 'delay' }
      ],
      formList: [
        {
          label: '所在小区',
          inputType: 'select',
          options: [],
          handle: ($event) => {
            let resetKey = ['buildingId', 'unitId', 'roomId'];
            this.resetSub(resetKey);
            this.communityChange(1, $event, 'formList');
          }, // 触发获取楼栋
          placeholder: '请选择所在小区',
          fetchOptions: this.getOptions,
          props: ['communityId', decoratorOptions.communityId]
        },
        {
          label: '所在楼栋',
          inputType: 'select',
          options: [],
          handle: ($event) => {
            let resetKey = ['unitId', 'roomId'];
            this.resetSub(resetKey);
            this.buildingChange(2, $event, 'formList');
          },
          placeholder: '请选择所在楼栋',
          props: ['buildingId', decoratorOptions.buildingId]
        },
        {
          label: '所在单元',
          inputType: 'select',
          options: [],
          handle: ($event) => {
            let resetKey = ['roomId'];
            this.resetSub(resetKey);
            this.unitChange(3, $event, 'formList');
          },
          placeholder: '请选择所在单元',
          props: ['unitId', decoratorOptions.unitId]
        },
        {
          label: '所在房间',
          inputType: 'select',
          options: [],
          placeholder: '请选择所在房间',
          props: ['roomId', decoratorOptions.roomId]
        },
        {
          label: '住户类型',
          inputType: 'select',
          options: [],
          placeholder: '请选择住户类型',
          props: ['householdType', decoratorOptions.householdType]
        },
        {
          label: '有效期至',
          inputType: 'datePick',
          options: [],
          placeholder: '',
          props: ['expireTime', decoratorOptions.expireTime]
        }
      ],
      fromOptions: {
        expireTime: {
          rules: [{ required: true, message: '请选择到期时间' }]
        }
      },
      addParam: {
        url: `/member/room/${this.$route.query.id}`,
        reqHandle: this.reqHandle,
        resHandle: this.addResHandle
      },
      columns: [
        { title: '所在城市', dataIndex: 'area', align: 'left', width: '' },
        { title: '小区', dataIndex: 'communityName', align: 'left', width: '' },
        { title: '房间', dataIndex: 'roomAddress', align: 'left', width: '' },
        { title: '住户类型', dataIndex: 'householdTypeDesc', align: 'left', width: '' },
        { title: '到期时间', dataIndex: 'expireTime', align: 'left', width: '', scopedSlots: {customRender: 'expireTime'} },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {},
      listApi: {
        url: `/member/rooms/${this.$route.query.id}`,
        resHandle: '',
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '/member/room/',
        // param: { pk_key: 'householder_info_id', pk_val: '' },
        title: '房间',
        key: 'roomAddress'
      }
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    getOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, 'formList', '0');
    },
    closeHouseVisible () {
      let resetKey = ['buildingId', 'unitId', 'roomId'];
      this.resetSub(resetKey);
      this.formList[0].searchValue = undefined;
      this.houseVisible = false;
    },
    getSelect () {
      // this.communitySelect(0, 'formList', 1);
      this.communitySelectByStep(1, undefined, 'formList', '0');
      this.dictionarySelect([{index: 4, scope: 'formList', query: 'comu_household_type'}]);
    },
    /* 添加房间弹窗 */
    addHouse () {
      this.communitySelectByStep(1, undefined, undefined, '0');
      this.houseVisible = true;
    },
    /* 房间续期弹窗 */
    openModal (row) {
      this.householderData = row;
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue({expireTime: Moment(row.expireTime)});
      });
    },
    /* 房间续期提交 */
    handleSubmit  () {
      this.form.validateFields((err, values) => {
        if (err) { return; }
        values.expireTime = values.expireTime.format('YYYY-MM-DD');
        this.$put({
          url: `/member/room/expire/${this.householderData.householderInfoId}`,
          params: values,
          btnLoading: this.btnLoading
        }).then((res) => {
          this.visible = false;
          this.$refs.table.getTableList();
          this.$message.success('续期成功！');
        });
      });
    },
    /* 添加房间提交前处理数据 */
    reqHandle (val) {
      val.expireTime = val.expireTime.format('YYYY-MM-DD');
      this.$refs.addEdit.routeQuery = '';
      return val;
    },
    addResHandle () {
      this.$message.success('添加成功！');
      this.closeHouseVisible();
      this.$refs.table.getTableList();
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>
